import axios from "../../http";
import {
  CART_ADD_ITEM,
  CART_REMOVE_ITEM,
  CART_CLEAR_ITEMS,
} from "../Constants/CartConstants";

// ADD TO CART
export const addToCart =
  (id, qty = 1, size = "", color = "") =>
  async (dispatch, getState) => {
    const { data } = await axios.get(`/api/products/${id}`);

    const productHasSizes =
      data.hasSizes === true &&
      Array.isArray(data.sizes) &&
      data.sizes.length > 0;

    const productHasColors =
      data.hasColors === true &&
      Array.isArray(data.colors) &&
      data.colors.length > 0;

    if (productHasSizes && !size) {
      throw new Error("Debes seleccionar una talla");
    }

    if (productHasColors && !color) {
      throw new Error("Debes seleccionar un color");
    }

    const finalSize = productHasSizes ? size : "";
    const finalColor = productHasColors ? color : "";

    const variantKey = `${data._id}_${finalSize || "sin-talla"}_${
      finalColor || "sin-color"
    }`;

    dispatch({
      type: CART_ADD_ITEM,
      payload: {
        product: data._id,
        name: data.name,
        image: data.image,
        price: Number(data.discountedPrice ?? data.price ?? 0),
        originalPrice: Number(data.price ?? 0),
        discount: Number(data.discount ?? 0),
        qty,
        size: finalSize,
        color: finalColor,
        variantKey,
      },
    });

    localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems));
  };

// REMOVE PRODUCT FROM CART
export const removefromcart = (variantKey) => (dispatch, getState) => {
  dispatch({
    type: CART_REMOVE_ITEM,
    payload: variantKey,
  });

  localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems));
};

// CLEAR CART
export const clearCartItems = () => (dispatch) => {
  dispatch({
    type: CART_CLEAR_ITEMS,
  });

  localStorage.removeItem("cartItems");
};